import {defineComponent} from 'vue';
import {useFormatting} from "@/composables/currency-format.ts";
import {storeToRefs} from "pinia";
import {useRoute} from "vue-router";
import {useWalletStore} from "@/app/stores/wallet-store.ts";
import {useAthumiService} from "@/app/stores/athumi-service-store.ts";

export default defineComponent({
    name: 'AegTopUpAvailableAmount',
    props: {
        availableAmount: {
            type: Number,
            required: true,
            default: 0
        },
        
    },
    setup() {
        const athumiService = useAthumiService();
        const { serviceTitle } = storeToRefs(athumiService);
        const {formatCurrency} = useFormatting();

        return {
            serviceTitle,
            formatCurrency
        }
    }
})
